function TC_generateUUID (allowUseOfServerUUID = false, forWho = '') {
    let crypto = window.crypto || window.msCrypto;

    // get randomUUID
    if (crypto && crypto.randomUUID) {
        let uuid = crypto.randomUUID();
        // console.log('randomUUID:', uuid, forWho);
        return uuid;
    }

    // if not available - fallback to getRandomValues
    if (window.Uint8Array && crypto && crypto.getRandomValues) {
        let bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        let uuid = Array.prototype.map.call(bytes, (b, i) => {
            return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
        }).join('');
        // console.log('getRandomValues UUID:', uuid, forWho);
        return uuid;
    }

    // If still not available and server-side UUID allowed (and exists) - use it
    if (
        allowUseOfServerUUID && 
        document.body.querySelector('.calmchristian-channels') && 
        document.body.querySelector('.calmchristian-channels').getAttribute('data-guid')
    ) {
        // console.log('Server UUID:', document.body.querySelector('.calmchristian-channels').getAttribute('data-guid'), forWho);
        return document.body.querySelector('.calmchristian-channels').getAttribute('data-guid');
    }

    // otherwise - use Math.random with timestamp as last resort
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
    });

    // console.log('Last resort UUID:', document.body.querySelector('.calmchristian-channels').getAttribute('data-guid'), forWho);
    return uuid;
}